import { render } from "./SubList.vue?vue&type=template&id=3bdf4bb1&scoped=true"
import script from "./SubList.vue?vue&type=script&lang=js"
export * from "./SubList.vue?vue&type=script&lang=js"

import "./SubList.vue?vue&type=style&index=0&id=3bdf4bb1&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdf4bb1"]])

export default __exports__